import { constants } from "../../../constants";

export default class ResumeGame {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    _default() {
        this.gb.emitters.emit.game.resumeGame();
    }

    PLAYTECH_handler(data) {
        if (data && data.features) {
            this.gb.ptResFeat = data.features;

            setTimeout(()=> {
                if (this.gb.ptResFeat && this.gb.ptResFeat.includes('loadingstatus')) {
                    let dataForPT = {_type: "ucip.loadingstatus.g2wLoadingStartNotification"}

                    this.gb.emitters.emit.web.customMsg(JSON.stringify(dataForPT));
                }
            },100)


            // if (this.gb.walletProtocol === constants.PLAYTECH && this.gb.gameProviderCode === 'GAM' && this.gb.ptResFeat && this.gb.ptResFeat.includes('loadingstatus')) {
            //     setTimeout(()=> {
            //         let dataForW = {_type: "ucip.loadingstatus.g2wLoadingProgressNotification", progress: 0}
            //         this.emitParent(JSON.stringify(dataForW));
            //     },100)
            // }
        }
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.walletProtocol) {
            case constants.EXCITE:
                event["playResumed"] = this._default
                break;
            case constants.MGS:
                event["ReStartGamePlay"] = this._default;
                event["RESUME_GAMEPLAY"] = this._default;
                event["resume_gameplay"] = this._default;
                break;
            case constants.POKERSTARS:
                event["xc2rgResumeGame"] = this._default;
                break;
            case constants.PLAYTECH:
                event["ucip.basic.w2gInitializationResponse"] = this.PLAYTECH_handler
                break;
            default:
                event["doGameResume"] = this._default
        }

        return event;
    }
}
